// Treasure Collect – Halloween (loaded by snippets/tc-halloween.liquid when the theme setting "Halloween" is on; styles in
// tc-halloween.css). Each zone has its own gesture:
//   hero        a purple night with stars, a harvest moon a witch flies across, bats (alone and in swarms out of the
//               moon), one bank of fog that runs on into the next section, jack-o'-lanterns with embers rising from them;
//               over the wall of displays (sections/tc-hero-wall) a lantern's flickering light, a few bats, and a ghost
//               seen only as a reflection gliding through the glass of the cases; on large screens, in the dark beside
//               it, the moon with the witch above the words and a corner of graveyard under them
//   headings    a small gold bat in the middle of the gold rule (CSS)
//   values      candlelight behind each icon, cobwebs in the corners
//   worlds      bats asleep upside down on bare branches
//   cream       cobwebs; a spider letting itself down; jack-o'-lanterns in the corners; leaves falling through
//               "Latest treasure drops"
//   trust       a ghost drifting by
//   newsletter  the Halloween banner: a garland of skulls and pumpkins, a night sky, a graveyard with a ghost rising
//   footer      (other pages) a graveyard with fog, jack-o'-lanterns, eyes in the dark and a ghost rising now and then
//   pages       mist on the dark title bands; on the product page a cobweb, a spider and jack-o'-lanterns on the photos,
//               the reviews band in fog; cobwebs and spiders on product cards and in the quick-add popup; a cobweb
//               and a spider in the empty cart (CSS); ghosts peeking in from the edges while scrolling
//   haunted     the spotlight at night (the Halloween collection with the code under it): ghosts floating, bats
//               hovering, orange sparkles; the code chips copy the code
//   collection  the Halloween collection's own page: the title band is the purple night with bats and swarms crossing
//               it, bats hang about the whole grid (peeking out from behind the cards) and fly over it now and then
//   music       a button plays a Halloween track (assets/tc-hw-music.mp3) on a loop, only when the visitor asks
// All of it is decoration: aria-hidden, no pointer events (except the spiders), and still when motion is reduced.
(() => {
  if (window.tcHalloweenReady) return;
  window.tcHalloweenReady = true;
  const T = window.tcHalloween || {};
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const phone = () => window.innerWidth < 750;
  const R = (a, b) => a + Math.random() * (b - a);
  const el = (tag, cls, html) => { const e = document.createElement(tag); if (cls) e.className = cls; if (html) e.innerHTML = html; e.setAttribute('aria-hidden', 'true'); return e; };
  const home = !!document.querySelector('.tc-home-hero');
  // the Halloween collection's own page (snippets/tc-halloween marks it)
  const onHaunted = document.documentElement.classList.contains('tc-hw-haunted');

  // animations run only while their zone is on screen
  const live = new IntersectionObserver((entries) => entries.forEach((en) => en.target.classList.toggle('tc-hw-live', en.isIntersecting)), { rootMargin: '80px 0px' });
  const zone = (e) => { e.classList.add('tc-hw-z'); live.observe(e); return e; };
  const host = (e) => { e.classList.add('tc-hw-host'); return e; };

  // ---------- shapes ----------
  // shared gradients, once per page (an SVG that is rendered but takes no room, so every drawing can use them)
  const DEFS = '<svg class="tc-hw-defs" width="0" height="0" aria-hidden="true" focusable="false"><defs>'
    + '<radialGradient id="tcHwPkB" cx="50%" cy="42%" r="62%"><stop offset="0" stop-color="#b9520f"/><stop offset=".7" stop-color="#7a3108"/><stop offset="1" stop-color="#3a1504"/></radialGradient>'
    + '<radialGradient id="tcHwPkM" cx="50%" cy="40%" r="62%"><stop offset="0" stop-color="#dc741b"/><stop offset=".66" stop-color="#a4490e"/><stop offset="1" stop-color="#4e1d05"/></radialGradient>'
    + '<radialGradient id="tcHwPkC" cx="46%" cy="36%" r="64%"><stop offset="0" stop-color="#f6962c"/><stop offset=".6" stop-color="#c85f12"/><stop offset="1" stop-color="#5e2407"/></radialGradient>'
    + '<radialGradient id="tcHwFire" cx="50%" cy="60%" r="65%"><stop offset="0" stop-color="#fff6c8"/><stop offset=".45" stop-color="#ffc24c"/><stop offset="1" stop-color="#ff7a14"/></radialGradient>'
    + '<radialGradient id="tcHwSpill" cx="50%" cy="50%" r="50%"><stop offset="0" stop-color="#ff9a2e" stop-opacity=".55"/><stop offset="1" stop-color="#ff9a2e" stop-opacity="0"/></radialGradient>'
    + '<linearGradient id="tcHwStem" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#5c6b2c"/><stop offset="1" stop-color="#27300f"/></linearGradient>'
    + '<linearGradient id="tcHwGhost" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".97"/><stop offset=".62" stop-color="#f1ecfb" stop-opacity=".78"/><stop offset="1" stop-color="#e6def6" stop-opacity=".1"/></linearGradient>'
    + '</defs></svg>';

  // path data in a centred space, moved (and mirrored) into a viewBox
  const place = (d, dx, dy, mirror) => {
    let i = 0;
    return d.replace(/-?\d*\.?\d+/g, (n) => { const v = parseFloat(n), x = i++ % 2 === 0; return String(Math.round((x ? (mirror ? -v : v) + dx : v + dy) * 100) / 100); });
  };
  const WING = 'M-2.5 -3C-6 -9.5 -13.5 -12.5 -21.5 -11.5C-26.5 -10.8 -30.5 -7.8 -33.5 -3.2C-30.6 -3.6 -28.6 -2.6 -27.6 -0.4C-25.6 -2.6 -22.4 -2.7 -20.8 -0.4C-18.8 -2.6 -15.6 -2.6 -14.1 -0.1C-12 -2 -8.6 -2 -6.6 0.6C-5 -1 -3.6 -1 -2.2 0.6Z';
  const BODY = 'M0 -7.4C0.9 -7.4 1.5 -6.3 1.8 -5L3.1 -8.4L3.7 -3.6C4.3 -2 4.3 2.2 3.1 4.7C2.1 6.7 -2.1 6.7 -3.1 4.7C-4.3 2.2 -4.3 -2 -3.7 -3.6L-3.1 -8.4L-1.8 -5C-1.5 -6.3 -0.9 -7.4 0 -7.4Z';
  const batSvg = () => `<svg viewBox="0 0 68 34" focusable="false"><path class="tc-hw-bat__w tc-hw-bat__w--l" d="${place(WING, 34, 17)}"/><path class="tc-hw-bat__w tc-hw-bat__w--r" d="${place(WING, 34, 17, true)}"/><path d="${place(BODY, 34, 17)}"/></svg>`;

  // a bat asleep upside down, wings wrapped round it, eyes that open now and then
  const HBAT = '<svg viewBox="0 0 30 44" focusable="false"><path d="M13 0.6V5M17 0.6V5" fill="none" stroke="#120e14" stroke-width="1.7" stroke-linecap="round"/>'
    + '<path fill="#120e14" d="M15 4.6C12 4.6 8 4 4 1.6L3.4 5.4C1.6 8.6 1.4 11.6 2.2 14C3.4 13.2 4.6 13.4 5.4 14.4C3.6 17.4 3.4 20.4 4.4 23.2C5.6 22.6 6.8 22.8 7.6 23.8C6.6 26.6 7 29.4 8.6 31.6C9.6 32.6 10.6 33.4 11.4 34L10.2 41.4L13.4 37.6H16.6L19.8 41.4L18.6 34C19.4 33.4 20.4 32.6 21.4 31.6C23 29.4 23.4 26.6 22.4 23.8C23.2 22.8 24.4 22.6 25.6 23.2C26.6 20.4 26.4 17.4 24.6 14.4C25.4 13.4 26.6 13.2 27.8 14C28.6 11.6 28.4 8.6 26.6 5.4L26 1.6C22 4 18 4.6 15 4.6Z"/>'
    + '<g class="tc-hw-hbat__eyes" fill="#f7b218"><circle cx="13.4" cy="34.6" r="1"/><circle cx="16.6" cy="34.6" r="1"/></g></svg>';

  // a bare branch coming in from the side, for the bats to hang from (400 x 60)
  const BRANCH = '<svg viewBox="0 0 400 60" preserveAspectRatio="xMinYMin meet" focusable="false"><path d="M-4 4C40 3 82 12 132 14C182 16 232 12 282 18.5C322 23 352 23 394 30.5L394.6 32.6C352 27.6 321 28.8 281 24.6C231 19.8 182 24.4 132 24C82 23.6 40 20 -4 21Z'
    + 'M70 15C78 6 87 2.6 97 1.6L97.4 3.6C88 5 81.4 8.8 75.4 16ZM150 19.4C160 10 170 6 182 4.2L182.6 6.2C172 8.2 164 12.4 156.4 20.8ZM250 18C258 26 266.4 30 278.4 31L278.2 33C265 33 255.6 29 246.6 20.6ZM331 25.6C339 18.4 347 15.2 357 14.2L357.2 16.2C348 17.2 341 21 335 27.2Z"/></svg>';

  // a carved pumpkin with a candle inside: five lobes, ribs, a stem and a glowing face (viewBox centred on the ground)
  const JACK = (k) => '<svg viewBox="-36 -48 72 56" focusable="false">'
    + '<ellipse class="tc-hw-spill" cx="0" cy="3" rx="36" ry="6" fill="url(#tcHwSpill)"/>'
    + '<path d="M-1.5 -30C-2.5 -37 -.5 -42 4 -45L7.5 -42C4 -39.5 3 -35 3.2 -30Z" fill="url(#tcHwStem)"/>'
    + '<ellipse cx="-15" cy="-13.5" rx="14.5" ry="16" fill="url(#tcHwPkB)"/><ellipse cx="15" cy="-13.5" rx="14.5" ry="16" fill="url(#tcHwPkB)"/>'
    + '<ellipse cx="-7.5" cy="-14.5" rx="13" ry="17.5" fill="url(#tcHwPkM)"/><ellipse cx="7.5" cy="-14.5" rx="13" ry="17.5" fill="url(#tcHwPkM)"/>'
    + '<ellipse cx="0" cy="-15" rx="10.5" ry="18.2" fill="url(#tcHwPkC)"/>'
    + '<path d="M-8.5 -31C-13 -22 -13 -8 -8.5 1.5M8.5 -31C13 -22 13 -8 8.5 1.5M-19 -27C-26 -19 -26 -6 -19 1M19 -27C26 -19 26 -6 19 1" fill="none" stroke="#4a1a04" stroke-opacity=".42" stroke-width="1"/>'
    + `<g class="tc-hw-face" style="--k:${k}"><ellipse cx="0" cy="-12" rx="18" ry="14" fill="url(#tcHwSpill)"/>`
    + '<path fill="url(#tcHwFire)" d="M-14.5 -19L-5 -19L-9.5 -26.5ZM14.5 -19L5 -19L9.5 -26.5ZM-2.2 -13.5L2.2 -13.5L0 -17.5ZM-15.5 -10C-10 -3.5 10 -3.5 15.5 -10C13.5 -1.5 7 2 0 2C-7 2 -13.5 -1.5 -15.5 -10Z"/>'
    + '<path fill="#d06a18" d="M-7.2 -6.2h3.2v3.2h-3.2zM4 -6.2h3.2v3.2h-3.2zM-1.6 -1.3h3.2v3.6h-3.2z"/></g></svg>';

  // a little sheet ghost
  const GHOST = '<svg viewBox="0 0 64 84" focusable="false"><path fill="url(#tcHwGhost)" d="M32 3C16 3 7 15.5 7 32V68C7 72.5 10.5 73.5 13 70C15.8 66 19 66 21.4 70.4C24 75.4 28.6 75.4 30.8 70.4C32.6 66.4 36 66.4 38 70.4C40.4 75.4 45 75.4 47.4 70.4C49.6 66 53 66 55.4 70C57.8 73.6 57 72.5 57 68V32C57 15.5 48 3 32 3Z"/>'
    + '<path fill="url(#tcHwGhost)" d="M8 38C2.5 40 .4 45.5 1.2 51C4.2 48 6.6 47.4 8.4 47.4ZM56 38C61.5 40 63.6 45.5 62.8 51C59.8 48 57.4 47.4 55.6 47.4Z"/>'
    + '<ellipse cx="23.5" cy="30" rx="3.8" ry="5.4" fill="#1b1522"/><ellipse cx="40.5" cy="30" rx="3.8" ry="5.4" fill="#1b1522"/>'
    + '<ellipse cx="32" cy="44" rx="4.2" ry="5.8" fill="#1b1522" fill-opacity=".82"/></svg>';

  // a witch on her broom, flying to the right (silhouette)
  const WITCH = '<svg viewBox="-16 -16 136 72" focusable="false">'
    + '<path d="M6 43.4L114 30.2L114.5 32.6L6.6 45.8Z"/>'
    + '<path d="M11 43.6C5 39.6 -3 37.6 -11 38.6C-7 41.6 -9 44.6 -14 47.6C-8 47.8 -3.6 50.6 -8 55.6C-1 53.4 5 50 12 46.4Z"/>'
    + '<path d="M54 37.2C55 30 57 24 63.4 18.6L70.4 16.4C73 17 74.6 18.6 75.6 21L86.6 28.8L88.2 32.2L84.8 32.6L78 28.4L75.8 34L84.2 35.4L87 44.2L91.4 46.2L91 48.4L84.6 48.2L80.4 41.4L72 47.6C66 49.6 60 49 56 45.4Z"/>'
    + '<path d="M62.6 19.6C52 21.6 41 19.4 29 25.6C35.4 26.6 37.6 29.6 33.6 33C41.6 32 47.6 33.4 50.2 37.8L56 33.6Z"/>'
    + '<path d="M68.4 10.2C69.4 7.2 73.4 6.8 75.4 9L78.6 11.6L75.8 12.2C75.2 15.2 72.2 17.2 69.6 15.8C67.6 14.6 67.2 12.2 68.4 10.2Z"/>'
    + '<path d="M68.6 13.4C62.6 15.4 58.6 14.4 54.2 17.6C59.2 18.6 62.6 18.6 67 16.6Z"/>'
    + '<path d="M62.6 9.8L84.6 6.2L85 8.2L63.2 11.6Z"/>'
    + '<path d="M67 9.4C68 3.4 69 -2.6 63.6 -10.4C72 -5.2 76 1 78.2 7.8Z"/></svg>';

  // autumn leaves: a maple and an oval one
  const MAPLE = 'M0 -11.5L2.2 -6.4L6.4 -8.6L5.2 -3.4L10.8 -3.6L7.6 -.2L9.8 3.2L4.4 3.2L4.6 6.6L1.2 4.4L.7 11.5L-.7 11.5L-1.2 4.4L-4.6 6.6L-4.4 3.2L-9.8 3.2L-7.6 -.2L-10.8 -3.6L-5.2 -3.4L-6.4 -8.6L-2.2 -6.4Z';
  const OVAL = 'M0 -11C7.5 -6 7.5 4.5 0 10C-7.5 4.5 -7.5 -6 0 -11Z';
  const LEAF_COLORS = ['#c2551b', '#d9862b', '#9c3d12', '#b5721c', '#e0a032'];
  const leaf = (maple, c) => `<svg viewBox="-12 -12 24 24" focusable="false"><path d="${maple ? MAPLE : OVAL}" fill="${c}" stroke="${c}" stroke-width="1" stroke-linejoin="round"/>`
    + `<path d="M0 -8V11${maple ? 'M0 1L-6 -2.5M0 1L6 -2.5' : 'M0 -3L-3.5 -5.5M0 1L3.8 -1.5M0 5L-3.2 2.6'}" fill="none" stroke="#000" stroke-opacity=".22" stroke-width=".7" stroke-linecap="round"/></svg>`;

  // a cobweb in the top left corner of a size x size box: threads fanning out, sagging rings between them
  const web = (size, seed) => {
    let s = seed;
    const rnd = () => { s = (s * 9301 + 49297) % 233280; return s / 233280; };
    const n = 7, rings = 5, ang = [], len = [];
    for (let k = 0; k < n; k++) { ang.push((Math.PI / 2) * (k / (n - 1)) * 0.96 + 0.02 + (rnd() - 0.5) * 0.06); len.push(size * (0.84 + rnd() * 0.16)); }
    let d = '';
    for (let k = 0; k < n; k++) d += `M0 0L${(Math.cos(ang[k]) * len[k]).toFixed(1)} ${(Math.sin(ang[k]) * len[k]).toFixed(1)}`;
    for (let r = 1; r <= rings; r++) {
      const f = r / (rings + 0.35);
      for (let k = 0; k < n - 1; k++) {
        if (r === rings && rnd() < 0.35) continue;   // a few strands of the outer ring are broken
        const r1 = f * len[k] * (0.97 + rnd() * 0.06), r2 = f * len[k + 1] * (0.97 + rnd() * 0.06);
        const x1 = Math.cos(ang[k]) * r1, y1 = Math.sin(ang[k]) * r1, x2 = Math.cos(ang[k + 1]) * r2, y2 = Math.sin(ang[k + 1]) * r2;
        const mid = (ang[k] + ang[k + 1]) / 2, rm = ((r1 + r2) / 2) * (0.8 - 0.04 * r);
        d += `M${x1.toFixed(1)} ${y1.toFixed(1)}Q${(Math.cos(mid) * rm).toFixed(1)} ${(Math.sin(mid) * rm).toFixed(1)} ${x2.toFixed(1)} ${y2.toFixed(1)}`;
      }
    }
    return `<svg viewBox="0 0 ${size} ${size}" focusable="false"><path d="${d}"/></svg>`;
  };

  const SPIDER = '<svg viewBox="0 0 40 40" focusable="false"><g fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M16 17L9 10L4 12M16 19L7 16L2 19M16 22L8 23L4 28M17 24L11 29L9 35"/><path d="M24 17L31 10L36 12M24 19L33 16L38 19M24 22L32 23L36 28M23 24L29 29L31 35"/></g>'
    + '<ellipse cx="20" cy="15" rx="3.6" ry="3.2" fill="currentColor"/><ellipse cx="20" cy="24" rx="6.2" ry="7" fill="currentColor"/>'
    + '<circle cx="18.6" cy="14.6" r=".9" fill="#f7b218"/><circle cx="21.4" cy="14.6" r=".9" fill="#f7b218"/></svg>';

  // a friendly skull (no blood): bone white, dark sockets with a small ember in each
  const SKULL = '<svg viewBox="0 0 40 44" focusable="false"><path fill="#efe7d6" d="M20 2C9.5 2 3 9.6 3 19C3 25.6 6.4 29.6 10 31.6V37.6C10 39.4 11.4 40.8 13.2 40.8H26.8C28.6 40.8 30 39.4 30 37.6V31.6C33.6 29.6 37 25.6 37 19C37 9.6 30.5 2 20 2Z"/>'
    + '<path fill="#cfc4ad" d="M30.4 6.4C34.8 9.6 37 14 37 19C37 25.6 33.6 29.6 30 31.6V37.6C30 39.4 28.6 40.8 26.8 40.8H24.6C26.4 40.8 27.4 39.4 27.4 37.6V30.6C31 28.4 33.6 24.4 33.6 18.6C33.6 13.4 32.4 9.4 30.4 6.4Z"/>'
    + '<path fill="#1b1420" d="M8.6 20.4C8.6 16.6 11.8 14.8 15 15.4C17.6 15.9 18.4 18.6 17.6 21.4C16.8 24.2 14 25.8 11.6 25.2C9.8 24.8 8.6 22.8 8.6 20.4ZM31.4 20.4C31.4 16.6 28.2 14.8 25 15.4C22.4 15.9 21.6 18.6 22.4 21.4C23.2 24.2 26 25.8 28.4 25.2C30.2 24.8 31.4 22.8 31.4 20.4ZM20 25.4L17.6 29.8H22.4Z"/>'
    + '<g class="tc-hw-skull__eyes" fill="#ff9a2e"><circle cx="13.4" cy="20.6" r="1.7"/><circle cx="26.6" cy="20.6" r="1.7"/></g>'
    + '<path d="M12.6 33.6H27.4M15.6 31.6V38.4M18.6 31.8V39M21.4 31.8V39M24.4 31.6V38.4" fill="none" stroke="#1b1420" stroke-width=".9" stroke-linecap="round" stroke-opacity=".75"/></svg>';

  // a drawing placed inside a bigger SVG
  const put = (svg, x, y, w, h) => svg.replace('<svg ', `<svg x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${w.toFixed(1)}" height="${h.toFixed(1)}" overflow="visible" `);
  const jackAt = (x, y, w, k) => put(JACK(k), x - w / 2, y - (w * 48) / 72, w, (w * 56) / 72);
  const ghostAt = (x, y, w) => `<g class="tc-hw-rise">${put(GHOST, x - w / 2, y, w, (w * 84) / 64)}</g>`;
  const skullAt = (x, y, w) => put(SKULL, x - w / 2, y - (w * 44) / 40, w, (w * 44) / 40);
  const eyes = (x, y, k) => `<g class="tc-hw-eyes" style="--k:${k}"><ellipse cx="${x}" cy="${y}" rx="2.1" ry="1.5"/><ellipse cx="${x + 7}" cy="${y}" rx="2.1" ry="1.5"/></g>`;
  const stone = (x, y, w, h) => `<path d="M${x - w / 2} ${y}L${x - w / 2} ${y - h + w / 2}A${w / 2} ${w / 2} 0 0 1 ${x + w / 2} ${y - h + w / 2}L${x + w / 2} ${y}Z"/>`;
  const cross = (x, y, h) => `<path d="M${x - 2.5} ${y}L${x - 2.5} ${y - h * 0.62}L${x - 9} ${y - h * 0.62}L${x - 9} ${y - h * 0.76}L${x - 2.5} ${y - h * 0.76}L${x - 2.5} ${y - h}L${x + 2.5} ${y - h}L${x + 2.5} ${y - h * 0.76}L${x + 9} ${y - h * 0.76}L${x + 9} ${y - h * 0.62}L${x + 2.5} ${y - h * 0.62}L${x + 2.5} ${y}Z"/>`;
  const fence = (x0, x1, y) => {
    let f = '';
    for (let x = x0; x <= x1; x += 12) f += `<path d="M${x - 1.5} ${y}L${x - 1.5} ${y - 24}L${x} ${y - 29}L${x + 1.5} ${y - 24}L${x + 1.5} ${y}Z"/>`;
    return f + `<rect x="${x0 - 4}" y="${y - 20}" width="${x1 - x0 + 8}" height="2.5"/><rect x="${x0 - 4}" y="${y - 8}" width="${x1 - x0 + 8}" height="2.5"/>`;
  };
  // a bare tree, its foot at (x, y)
  const tree = (x, y, s) => `<g transform="translate(${x} ${y}) scale(${s}) translate(-874 -84)">`
    + '<path d="M872 84C874 70 873 58 868 46C864 38 858 33 850 30L851 28C860 30 866 35 870 41C871 33 868 25 862 19L864 18C871 24 874 33 873 41C876 34 882 29 890 27L891 29C884 31 879 36 876 43C880 52 881 66 880 84Z"/>'
    + '<path d="M869 44C860 41 852 42 844 46L843 44C851 39 860 38 869 41ZM876 48C886 45 896 46 904 52L903 54C895 49 886 48 877 51Z"/></g>';
  const stars = (n) => {
    let s = '';
    for (let i = 0; i < n; i++) s += `<i class="tc-hw-star" style="--x:${R(2, 98).toFixed(1)}%;--y:${R(3, 46).toFixed(1)}%;--s:${R(0.6, 1.4).toFixed(2)};--d:${(-R(0, 4)).toFixed(2)}s"></i>`;
    return `<span class="tc-hw-stars">${s}</span>`;
  };

  // the graveyard along the top of the footer (1440 x 110, kept centred when the screen is narrower)
  const YARD = '<svg viewBox="0 0 1440 110" preserveAspectRatio="xMidYMax slice" focusable="false"><defs>'
    + '<linearGradient id="tcHwGround" x1="0" y1="0" x2="0" y2="1"><stop offset="0" style="stop-color:var(--tc-hw-ground-top,#0b0a0d)"/><stop offset="1" style="stop-color:var(--tc-hw-ground,#171717)"/></linearGradient></defs>'
    + '<ellipse class="tc-hw-glow" cx="736" cy="84" rx="170" ry="40" fill="url(#tcHwSpill)"/>'
    + ghostAt(1000, 34, 22)
    + '<g class="tc-hw-yard__ink">'
    + stone(170, 84, 26, 36) + cross(238, 84, 40) + stone(300, 86, 20, 26) + stone(1000, 82, 30, 42) + cross(1072, 80, 44) + stone(1290, 84, 24, 32) + stone(1356, 86, 18, 22)
    + fence(560, 660, 82) + tree(874, 84, 1)
    + '</g>'
    + '<g class="tc-hw-eyes-all">' + eyes(512, 70, 0) + eyes(1118, 66, 1) + eyes(212, 72, 2) + '</g>'
    + '<path d="M0 110L0 86C110 80 220 90 340 85C470 79 560 78 700 86C820 92 930 80 1060 82C1190 84 1300 76 1440 82L1440 110Z" fill="url(#tcHwGround)"/>'
    + skullAt(332, 92, 14)
    + jackAt(150, 96, 30, 6) + jackAt(452, 94, 30, 3) + jackAt(700, 96, 46, 0) + jackAt(742, 97, 36, 1) + jackAt(776, 96, 28, 2)
    + jackAt(930, 95, 34, 4) + jackAt(966, 97, 24, 5) + jackAt(1240, 96, 30, 7)
    + '</svg>';

  // a quiet corner of graveyard in the dark under the words of the wall of displays (240 x 110, kept to the left): a
  // cross and a tomb on a low mound, a jack-o'-lantern and a skull at their feet
  const GRAVE = '<svg viewBox="0 0 240 110" preserveAspectRatio="xMinYMax meet" focusable="false">'
    + '<ellipse class="tc-hw-glow" cx="66" cy="102" rx="60" ry="14" fill="url(#tcHwSpill)"/>'
    + '<g class="tc-hw-yard__ink">' + cross(38, 94, 40) + stone(92, 96, 26, 36) + '</g>'
    + '<path class="tc-hw-grave__ground" d="M0 110L0 97C40 91 90 92 140 97C170 100 200 102 240 105L240 110Z"/>'
    + skullAt(124, 106, 11)
    + jackAt(64, 108, 30, 0)
    + '</svg>';

  // the graveyard of the Halloween banner (1440 x 220): hills far away, the yard in front
  const SCENE = '<svg class="tc-hw-scene" viewBox="0 0 1440 220" preserveAspectRatio="xMidYMax slice" focusable="false">'
    + '<path class="tc-hw-scene__far" d="M0 220V150C120 128 240 140 360 132C480 124 560 146 700 138C840 130 940 112 1080 126C1200 138 1320 120 1440 130V220Z"/>'
    + '<g class="tc-hw-scene__far2">' + cross(330, 136, 24) + stone(395, 134, 14, 18) + stone(1150, 132, 14, 18) + cross(1200, 134, 22) + tree(760, 140, 0.7) + '</g>'
    + '<ellipse class="tc-hw-glow" cx="690" cy="196" rx="190" ry="34" fill="url(#tcHwSpill)"/>'
    + ghostAt(560, 116, 30)
    + '<g class="tc-hw-scene__ink">'
    + stone(160, 188, 26, 34) + cross(250, 186, 44) + cross(430, 182, 56) + stone(482, 184, 30, 40) + stone(560, 182, 44, 62)
    + fence(600, 650, 184) + tree(900, 182, 1.65) + stone(968, 184, 34, 46) + cross(1020, 182, 60) + stone(1240, 186, 26, 34) + cross(1330, 186, 42)
    + '<path d="M0 220V182C140 174 280 188 420 180C560 172 640 178 720 184C820 192 960 174 1100 178C1240 182 1340 172 1440 176V220Z"/>'
    + '</g>'
    + '<g class="tc-hw-eyes-all">' + eyes(512, 166, 0) + eyes(930, 140, 1) + eyes(1286, 170, 2) + '</g>'
    + skullAt(764, 196, 18)
    + jackAt(300, 194, 36, 3) + jackAt(660, 194, 48, 0) + jackAt(708, 197, 34, 1) + jackAt(820, 198, 26, 4) + jackAt(1120, 192, 40, 2)
    + '</svg>';

  // the garland strung across the top of the banner (the string is a curve in a 100 x 44 box)
  const garland = () => {
    const n = phone() ? 7 : 15;
    let items = '';
    for (let i = 0; i < n; i++) {
      const t = (i + 0.5) / n, y = 4 + 144 * t * (1 - t);
      const skull = i % 2 === 0;
      items += `<span class="tc-hw-charm tc-hw-charm--${skull ? 'skull' : 'jack'}" style="--x:${(t * 100).toFixed(2)}%;--y:${((y / 44) * 100).toFixed(2)}%;--k:${i}">${skull ? SKULL : JACK(i)}</span>`;
    }
    return '<svg class="tc-hw-garland__string" viewBox="0 0 100 44" preserveAspectRatio="none" focusable="false"><path d="M0 4Q50 76 100 4"/></svg>' + items;
  };

  // ---------- building blocks ----------
  const fog = (kind) => el('span', 'tc-hw-fog tc-hw-fog--' + kind, '<span></span>');
  const mist = (h) => {
    if (h.querySelector(':scope > .tc-hw-mist')) return;
    const m = zone(el('span', 'tc-hw-mist'));
    m.append(fog('back'), fog('front'));
    host(h).append(m);
  };
  const webs = (h, dark, seed) => {
    if (h.querySelector(':scope > .tc-hw-web')) return;
    const c = 'tc-hw-web' + (dark ? ' tc-hw-web--dark' : '');
    host(h).append(el('span', c + ' tc-hw-web--l', web(150, seed)), el('span', c + ' tc-hw-web--r', web(150, seed + 18)));
  };
  const spider = (h, side, len, cls) => {
    const sp = zone(el('span', `tc-hw-spider tc-hw-spider--${side}${cls ? ' ' + cls : ''}`, `<span class="tc-hw-spider__thread"></span><span class="tc-hw-spider__body">${SPIDER}</span>`));
    if (len) sp.style.setProperty('--len', len);
    h.append(sp);
    return sp;
  };
  // jack-o'-lanterns side by side (sizes relative to --jw), embers rising from them
  const patch = (side, sizes, embers, cls) => {
    const p = zone(el('span', `tc-hw-patch tc-hw-patch--${side}${cls ? ' ' + cls : ''}`));
    sizes.forEach((s, k) => { const j = el('span', 'tc-hw-jack', JACK(k + (side === 'r' ? 3 : 0))); j.style.setProperty('--s', s); p.append(j); });
    if (!reduce) for (let k = 0; k < embers; k++) {
      const e = el('i', 'tc-hw-ember');
      // embers drift towards the middle of the page, so they never leave the screen at its edges
      e.style.cssText = `--x:${R(12, 88).toFixed(0)}%;--dx:${(side === 'r' ? -R(0, 18) : R(0, 18)).toFixed(0)}px;--t:${R(3.6, 6).toFixed(2)}s;--d:${(-R(0, 6)).toFixed(2)}s`;
      p.append(e);
    }
    return p;
  };
  const corners = (h, left, right, embers) => {
    if (h.querySelector(':scope > .tc-hw-patch')) return;
    host(h).append(patch('l', left, embers, 'tc-hw-patch--corner'), patch('r', right, embers, 'tc-hw-patch--corner'));
  };

  // ---------- zones ----------
  const hero = () => {
    document.querySelectorAll('.tc-home-hero .swiper-slide').forEach((slide, i) => {
      const media = slide.querySelector('.slideshow__media');
      if (!media || media.querySelector('.tc-hw-night')) return;
      const night = zone(el('span', 'tc-hw-night'));
      const moon = el('span', 'tc-hw-moonbox', '<span class="tc-hw-moon"></span>' + (i === 0 && !reduce ? `<span class="tc-hw-witch">${WITCH}</span>` : ''));
      const bats = el('span', 'tc-hw-bats');
      const sky = el('span', 'tc-hw-sky');
      sky.innerHTML = stars(phone() ? 14 : 26);
      night.append(sky, moon, fog('back'), bats, fog('front'), patch('l', [1, 0.72, 0.5], 7), patch('r', [0.86, 0.6], 5));
      media.append(night);
      if (!reduce && i === 0) flyBats(night, bats);
    });
    // the wall of displays: the displays stay the picture, and the night happens around them. The light that wanders
    // over the wall is a lantern's (the styles), a few bats cross in front of the cases, and now and then a ghost
    // passes behind the visitor: it is seen only as a reflection gliding through the glass of the cases, one after
    // another along a row (glassGhosts). Over the wall's shade, under the words
    document.querySelectorAll('.tc-home-hero .tc-wall').forEach((wall) => {
      if (wall.querySelector(':scope > .tc-hw-wallnight')) return;
      const night = zone(el('span', 'tc-hw-wallnight'));
      const bats = el('span', 'tc-hw-bats');
      // large screens: the dark beside the wall, above and under the words, keeps the night of the season: the harvest
      // moon with the witch crossing it and a few stars above, a quiet corner of graveyard below. Only as wide as
      // the words (--text-r, from the wall's script), so it never covers the displays; the styles show it from 990px
      const side = el('span', 'tc-hw-darkside', stars(10)
        + '<span class="tc-hw-moonbox"><span class="tc-hw-moon"></span>' + (reduce ? '' : `<span class="tc-hw-witch">${WITCH}</span>`) + '</span>'
        + `<span class="tc-hw-grave">${GRAVE}</span>`);
      night.append(side, bats);
      wall.append(night);
      if (reduce) return;
      glideBats(night, bats, phone() ? 2 : 3, phone() ? [0.14, 0.3] : [0.16, 0.4]);
      glassGhosts(wall);
    });
  };

  // the bats over the wall of displays, smooth on any phone: each bat is three still drawings (the body and the two
  // wings, glow included, drawn once), the wings beat as the other bats' do and the bat flies along its path,
  // all moves the browser hands to the graphics card (transform and opacity), so nothing is drawn again and the busy
  // wall never makes them stutter. A bat crosses on a gentle swooping path, banking with it and growing a little as
  // it comes closer, then waits a few seconds out of view; still while the hero is off screen
  const glideBats = (night, layer, n, band) => {
    const part = (cls, d) => `<span class="tc-hw-fbat__${cls}"><svg viewBox="0 0 68 34" focusable="false"><path d="${d}"/></svg></span>`;
    const look = part('wing tc-hw-fbat__wing--l', place(WING, 34, 17)) + part('wing tc-hw-fbat__wing--r', place(WING, 34, 17, true)) + part('body', place(BODY, 34, 17));
    let on = false;
    const bats = [];
    const fly = (bat) => {
      const w = night.clientWidth, h = night.clientHeight, ph = w < 750;
      if (!w || !h) { bat.timer = setTimeout(() => fly(bat), 2000); return; }
      const ltr = Math.random() < 0.5, near = Math.random();
      const size = (ph ? 0.5 : 0.72) + near * (ph ? 0.35 : 0.5);
      const y0 = h * R(band[0], band[1]), amp = h * R(0.03, 0.08), waves = R(1.2, 2.2), ph0 = R(0, 6.3);
      const x0 = ltr ? -90 : w + 90, x1 = ltr ? w + 90 : -90, span = Math.abs(x1 - x0);
      const keys = [];
      for (let k = 0; k <= 48; k++) {
        const t = k / 48, a = t * Math.PI * 2 * waves + ph0;
        const x = x0 + (x1 - x0) * t, y = y0 + Math.sin(a) * amp;
        const tilt = Math.max(-16, Math.min(16, Math.atan((Math.cos(a) * amp * Math.PI * 2 * waves) / span) * 57)) * (ltr ? 1 : -1);
        const s = size * (0.86 + 0.14 * Math.sin(t * Math.PI));
        keys.push({ transform: `translate3d(${x.toFixed(1)}px, ${y.toFixed(1)}px, 0) rotate(${tilt.toFixed(1)}deg) scale(${s.toFixed(3)})`, opacity: +(Math.min(1, t * 10, (1 - t) * 10) * (0.62 + near * 0.38)).toFixed(3) });
      }
      bat.el.style.setProperty('--flap', (0.16 + (1 - near) * 0.08).toFixed(3) + 's');
      bat.anim = bat.el.animate(keys, { duration: (ph ? 6500 : 9500) + R(0, 3000) - near * 1500, easing: 'linear', fill: 'both' });
      if (!on) bat.anim.pause();
      bat.anim.onfinish = () => { bat.anim = null; bat.timer = setTimeout(() => fly(bat), R(3000, 9000)); };
    };
    for (let i = 0; i < n; i++) {
      const bat = { el: el('span', 'tc-hw-fbat', look), anim: null, timer: 0 };
      layer.append(bat.el);
      bats.push(bat);
      bat.timer = setTimeout(() => fly(bat), 1200 + i * R(2400, 3400));
    }
    new IntersectionObserver(([en]) => {
      on = en.isIntersecting && !document.hidden;
      bats.forEach((b) => { if (b.anim) { if (on) b.anim.play(); else b.anim.pause(); } });
    }).observe(night);
  };

  // a ghost reflected in the glass: every 10-16 s, on a row in view, it glides through two or three lit acrylic cases
  // side by side, entering each as it leaves the one before. Only where the words are not (on large screens the wall
  // right of them, on phones the rows above and below them)
  const glassGhosts = (wall) => {
    let on = false;
    new IntersectionObserver(([en]) => { on = en.isIntersecting; }).observe(wall);
    const DUR = 2.6;
    const pass = () => {
      setTimeout(pass, R(10000, 16000));
      if (!on || document.hidden) return;
      const W = wall.clientWidth, ph = window.innerWidth < 990;
      const rows = [...wall.querySelectorAll('.tc-wall__row')].filter((r, i, all) => !ph || i !== (all.length - 1) / 2);
      const row = rows[Math.floor(Math.random() * rows.length)];
      if (!row) return;
      const w0 = wall.getBoundingClientRect().left;
      const seen = [...row.querySelectorAll('.tc-wall__tile[data-k="a"].is-lit')]
        .map((t) => ({ t, b: t.getBoundingClientRect() }))
        .filter((o) => o.b.width && o.b.left - w0 > (ph ? 0 : W * 0.42) && o.b.right - w0 < W)
        .sort((a, b) => a.b.left - b.b.left);
      if (seen.length < 2) return;
      const ltr = Math.random() < 0.5;
      const start = Math.floor(Math.random() * Math.max(1, seen.length - 2));
      let run = seen.slice(start, start + 3);
      if (!ltr) run = run.reverse();
      // each ghost in a box of the size of the glass, which keeps it inside the case
      run.forEach((o, k) => {
        if (o.t.querySelector(':scope > .tc-hw-glassbox')) return;
        const box = el('span', 'tc-hw-glassbox', `<span class="tc-hw-glassghost${ltr ? '' : ' tc-hw-glassghost--rtl'}"><span>${GHOST}</span></span>`);
        const g = box.firstChild;
        g.style.setProperty('--gd', (k * DUR * 0.62).toFixed(2) + 's');
        g.style.setProperty('--gt', DUR + 's');
        g.style.setProperty('--gy', R(8, 30).toFixed(1) + '%');
        o.t.append(box);
        setTimeout(() => box.remove(), (k * DUR * 0.62 + DUR) * 1000 + 300);
      });
    };
    setTimeout(pass, R(5000, 7000));
  };

  // bats cross the sky now and then along a gentle wave, the far ones smaller and paler; every 15-25 s a swarm
  // pours out of the moon
  const flyBats = (night, layer, opt = {}) => {
    const ph = phone(), moonEl = opt.edge ? null : night.querySelector('.tc-hw-moon');
    const band = opt.band || [0.14, ph ? 0.36 : 0.44];
    const make = (cls) => { const b = el('span', 'tc-hw-bat' + (cls ? ' ' + cls : ''), batSvg()); layer.append(b); return { el: b, p: null }; };
    const solo = [], swarm = [];
    for (let i = 0; i < (opt.solo || (ph ? 3 : 4)); i++) { const b = make(); b.start = performance.now() + 900 + i * (ph ? 2600 : 2100) + R(0, 900); solo.push(b); }
    for (let i = 0; i < (ph ? 6 : 9); i++) swarm.push(make('tc-hw-bat--far'));
    let nextSwarm = performance.now() + R(4500, 6500);
    const plan = (bat, now) => {
      const w = night.clientWidth, h = night.clientHeight;
      const ltr = Math.random() < 0.5, near = Math.random();
      bat.p = {
        t0: now, dur: (ph ? 5200 : 7600) + R(0, 3200) - near * 1200,
        x0: ltr ? -90 : w + 90, x1: ltr ? w + 90 : -90,
        y0: h * R(band[0], band[1]), amp: h * R(0.04, 0.11), waves: R(1, 2.2), ph: R(0, 6.3),
        size: (ph ? 0.5 : 0.8) + near * (ph ? 0.42 : 0.62), alpha: 0.55 + near * 0.4, ltr,
      };
      bat.el.style.setProperty('--flap', (0.16 + (1 - near) * 0.08).toFixed(3) + 's');
      bat.el.style.opacity = 0;
    };
    // out of the moon, growing as they come closer; with no moon (opt.edge) in from the right edge at full size
    const launch = (now) => {
      const n = night.getBoundingClientRect(), m = moonEl ? moonEl.getBoundingClientRect() : null;
      const cx = m ? m.left - n.left + m.width / 2 : n.width + 50, cy = m ? m.top - n.top + m.height / 2 : n.height * R(band[0] + 0.05, band[1]);
      const dist = n.width * (m ? R(0.75, 1) : R(1.1, 1.25)), s0 = m ? (ph ? 0.14 : 0.2) : (ph ? 0.36 : 0.5);
      swarm.forEach((b, j) => {
        const ang = Math.PI + (m ? R(-0.55, 0.32) : R(-0.22, 0.22));
        b.p = { t0: now + j * R(70, 170), dur: R(2600, 3800) * (m ? 1 : 1.5), cx, cy, dx: Math.cos(ang) * dist, dy: Math.sin(ang) * dist * 0.6, s0, s1: (m ? (ph ? 0.38 : 0.5) : s0) + R(0, ph ? 0.25 : 0.4), ph: R(0, 6.3) };
        b.el.style.setProperty('--flap', R(0.1, 0.14).toFixed(3) + 's');
      });
    };
    let on = false;
    new IntersectionObserver(([en]) => { on = en.isIntersecting; }).observe(night);
    const tick = (now) => {
      if (on && !document.hidden) {
        solo.forEach((bat) => {
          if (now < bat.start) return;
          if (!bat.p) plan(bat, now);
          const p = bat.p, t = (now - p.t0) / p.dur;
          if (t >= 1) { bat.p = null; bat.start = now + R(2200, 8700); bat.el.style.opacity = 0; return; }
          const x = p.x0 + (p.x1 - p.x0) * t;
          const y = p.y0 + Math.sin(t * Math.PI * 2 * p.waves + p.ph) * p.amp + Math.sin(now / 90 + p.ph) * 1.6;
          const dy = (Math.cos(t * Math.PI * 2 * p.waves + p.ph) * p.amp * Math.PI * 2 * p.waves) / Math.abs(p.x1 - p.x0);
          const tilt = Math.max(-18, Math.min(18, Math.atan(dy) * 57)) * (p.ltr ? 1 : -1);
          bat.el.style.transform = `translate3d(${x.toFixed(1)}px, ${y.toFixed(1)}px, 0) rotate(${tilt.toFixed(1)}deg) scale(${p.size.toFixed(3)})`;
          bat.el.style.opacity = (p.alpha * Math.min(1, t * 8, (1 - t) * 8)).toFixed(3);
        });
        if (((moonEl && moonEl.offsetWidth) || opt.edge) && now > nextSwarm) { launch(now); nextSwarm = now + R(15000, 25000); }
        swarm.forEach((b) => {
          const p = b.p;
          if (!p) return;
          const t = (now - p.t0) / p.dur;
          if (t < 0) { b.el.style.opacity = 0; return; }
          if (t >= 1) { b.p = null; b.el.style.opacity = 0; return; }
          const e = Math.pow(t, 1.25);
          const x = p.cx + p.dx * e, y = p.cy + p.dy * e + Math.sin(t * 9 + p.ph) * 6;
          b.el.style.transform = `translate3d(${x.toFixed(1)}px, ${y.toFixed(1)}px, 0) rotate(${(Math.sin(t * 7 + p.ph) * 12).toFixed(1)}deg) scale(${(p.s0 + (p.s1 - p.s0) * t).toFixed(3)})`;
          b.el.style.opacity = (Math.min(1, t * 6, (1 - t) * 5) * 0.92).toFixed(3);
        });
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const values = () => {
    document.querySelectorAll('.tc-home--values').forEach((sec) => {
      webs(sec, true, 3);
    });
    document.querySelectorAll('.tc-home--values .tc-home__value').forEach((v, i) => {
      if (v.querySelector('.tc-hw-candle')) return;
      const c = zone(el('span', 'tc-hw-candle'));
      c.style.setProperty('--k', i);
      v.prepend(c);
    });
  };

  // bats asleep on two branches; where they hang is measured on the branch drawing (400 x 60)
  const worlds = () => {
    document.querySelectorAll('.tc-home--universes').forEach((sec) => {
      if (sec.querySelector('.tc-hw-branch')) return;
      host(sec);
      ['l', 'r'].forEach((side, n) => {
        const b = zone(el('span', 'tc-hw-branch tc-hw-branch--' + side, BRANCH));
        [[37.5, 39, 1], [59, 34.5, 0.8], [79.5, 45.5, 0.92]].forEach(([x, y, s], k) => {
          const bat = el('span', 'tc-hw-hbat', HBAT);
          bat.style.cssText = `--x:${x}%;--y:${y}%;--s:${s};--k:${k + n * 3}`;
          b.append(bat);
        });
        sec.append(b);
      });
    });
  };

  const leaves = (h) => {
    if (reduce || h.querySelector(':scope > .tc-hw-leaves')) return;
    const box = zone(el('span', 'tc-hw-leaves'));
    const n = phone() ? 6 : 10;
    for (let i = 0; i < n; i++) {
      const l = el('i', 'tc-hw-leaf', leaf(i % 3 !== 1, LEAF_COLORS[i % LEAF_COLORS.length]));
      l.style.cssText = `--x:${(4 + (92 * (i + R(0.1, 0.9))) / n).toFixed(1)}%;--s:${R(0.75, 1.25).toFixed(2)};--t:${R(11, 17).toFixed(1)}s;--d:${(-R(0, 17)).toFixed(1)}s;--sw:${R(18, 46).toFixed(0)}px;--r:${Math.random() < 0.5 ? 1 : -1}`;
      box.append(l);
    }
    host(h).append(box);
  };

  const light = () => {
    document.querySelectorAll('.tc-home--spotlight').forEach((sec, i) => {
      if (sec.querySelector(':scope > .tc-hw-web')) return;
      // the haunted treasures are a night: pale cobwebs and jack-o'-lanterns, no spider (promo() adds the ghosts)
      if (sec.classList.contains('tc-home--hwpicks') || (onHaunted && sec.classList.contains('tc-collection'))) { webs(sec, true, 13); corners(sec, [1, 0.62], [0.8], 3); return; }
      webs(sec, false, 11 + i * 7);
      if (home && sec.classList.contains('tc-home--latest')) { leaves(sec); return; }
      const plain = home && !sec.classList.contains('tc-home--bundles');
      spider(sec, plain ? 'l' : 'r', plain ? null : phone() ? '30px' : '70px');
      corners(sec, [1, 0.62], [0.8], 3);
    });
  };

  const trust = () => {
    document.querySelectorAll('.tc-home--trust').forEach((sec) => {
      if (sec.querySelector('.tc-hw-ghostway')) return;
      webs(sec, true, 5);
      if (!reduce) sec.append(zone(el('span', 'tc-hw-ghostway', `<span class="tc-hw-ghost"><span>${GHOST}</span></span>`)));
    });
    document.querySelectorAll('.tc-home--faq').forEach((sec) => webs(sec, true, 8));
  };

  // the newsletter becomes the Halloween banner; the garland needs room above the title
  const banner = () => {
    document.querySelectorAll('.tc-home--newsletter').forEach((sec) => {
      if (sec.querySelector('.tc-hw-banner')) return;
      const gh = phone() ? 44 : 60, room = phone() ? 56 : 72;
      host(sec).classList.add('tc-hw-bannerhost');
      sec.style.setProperty('--tc-hw-gh', gh + 'px');
      sec.style.paddingTop = parseFloat(getComputedStyle(sec).paddingTop) + room + 'px';
      const b = zone(el('span', 'tc-hw-banner', '<span class="tc-hw-banner__sky"></span>' + stars(phone() ? 16 : 30) + '<span class="tc-hw-banner__moon"></span>' + SCENE));
      b.append(fog('front'));
      sec.prepend(zone(el('span', 'tc-hw-garland', garland())));
      sec.prepend(b);
    });
  };

  const footer = () => {
    const f = document.querySelector('footer.tc-footer');
    if (!f || home || f.querySelector('.tc-hw-yard')) return;
    const bg = getComputedStyle(f).backgroundColor;
    const yard = zone(el('div', 'tc-hw-yard', YARD));
    yard.append(fog('front'));
    if (bg && bg !== 'rgba(0, 0, 0, 0)') yard.style.setProperty('--tc-hw-ground', bg);
    f.prepend(yard);
  };

  const pages = () => {
    if (home) return;
    document.querySelectorAll('.breadcrumb-section').forEach((sec) => { if (sec.offsetHeight >= 120) mist(sec); });
  };

  const product = () => {
    const sec = document.querySelector('section.main-product-template');
    if (!sec) return;
    // the photos: a cobweb in their corner, a spider letting itself down, jack-o'-lanterns at their foot
    const frame = sec.querySelector('.GalleryViewerMain');
    if (frame && !frame.querySelector(':scope > .tc-hw-web')) {
      frame.append(el('span', 'tc-hw-web tc-hw-web--l tc-hw-web--over', web(150, 9)));
      spider(frame, 'r', phone() ? '64px' : '120px', 'tc-hw-spider--photo');
      frame.append(patch('r', [0.9, 0.62], 4, 'tc-hw-patch--gallery'));
    }
    sec.querySelectorAll('.tc-pdp-reviews').forEach((r) => { webs(r, true, 4); mist(r); corners(r, [0.9, 0.6], [0.75], 3); });
  };

  // a spider in the corner of every quick-add popup (the popup itself is positioned, so no host class)
  const popups = () => {
    document.querySelectorAll('quick-add-modal .quick-add-modal__content').forEach((c) => {
      if (!c.querySelector(':scope > .tc-hw-spider')) spider(c, 'l', '46px', 'tc-hw-spider--popup');
    });
  };

  // product cards: a spider drops in when the pointer comes over them
  const cards = () => {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    document.addEventListener('mouseover', (e) => {
      const card = e.target.closest && e.target.closest('.tc-home__product');
      const img = card && card.querySelector('.tc-home__product-image');
      if (!img || img.querySelector('.tc-hw-cardspider')) return;
      const sp = el('span', 'tc-hw-cardspider', `<span class="tc-hw-spider__thread"></span><span class="tc-hw-spider__body">${SPIDER}</span>`);
      img.append(sp);
      requestAnimationFrame(() => requestAnimationFrame(() => sp.classList.add('is-ready')));
    });
  };

  // a ghost peeks in from the side of the screen now and then while scrolling
  const peeks = () => {
    if (reduce || document.querySelector('.tc-hw-peeks')) return;
    const layer = el('span', 'tc-hw-peeks');
    document.body.append(layer);
    let last = window.scrollY, acc = 0, busy = false;
    window.addEventListener('scroll', () => {
      acc += Math.abs(window.scrollY - last);
      last = window.scrollY;
      if (busy || acc < (phone() ? 1400 : 1800) || window.scrollY < window.innerHeight * 0.6) return;
      acc = 0;
      busy = true;
      const g = el('span', 'tc-hw-peek tc-hw-peek--' + (Math.random() < 0.5 ? 'l' : 'r'), `<span>${GHOST}</span>`);
      g.style.top = R(24, 60).toFixed(0) + '%';
      layer.append(g);
      setTimeout(() => { g.remove(); busy = false; }, 4300);
    }, { passive: true });
  };

  // the haunted treasures (the spotlight at night): ghosts beside the title, bats hovering, sparkles like the poster's;
  // on wide screens they keep to the sides of the title and the cards, never over them
  const promo = () => {
    document.querySelectorAll('.tc-home--hwpicks').forEach((box) => {
      if (box.querySelector(':scope > .tc-hw-promo__fx')) return;
      const ghost = (x, y, w, side, d) => `<span class="tc-hw-promo__ghost tc-hw-promo__ghost--${side}" style="--x:${x};--y:${y}%;--w:${w}px;--d:${d}s"><span>${GHOST}</span></span>`;
      const bat = (x, y, sc, d) => `<span class="tc-hw-promo__bat" style="--x:${x};--y:${y}%;--s:${sc};--d:${d}s;--t:${R(5, 7.5).toFixed(2)}s">${batSvg()}</span>`;
      const spark = (x, y, w, d) => `<i class="tc-hw-promo__spark" style="--x:${x};--y:${y}%;--w:${w}px;--d:${d}s"></i>`;
      const h = phone()
        ? ghost('8%', 1.5, 34, 'l', 0) + ghost('92%', 66, 32, 'r', -1.7) + bat('84%', 2, 0.42, 0) + bat('12%', 70, 0.36, -2.4)
          + spark('20%', 14, 9, 0) + spark('86%', 16, 8, -1.4) + spark('6%', 58, 8, -2.2) + spark('94%', 88, 9, -0.8)
        : ghost('calc(50% - 330px)', 3, 74, 'l', 0) + ghost('calc(50% + 330px)', 7, 66, 'r', -1.7)
          + bat('max(5%, calc(50% - 600px))', 30, 0.8, 0) + bat('min(95%, calc(50% + 590px))', 46, 0.66, -2.4) + bat('calc(50% + 200px)', 2, 0.5, -1.2)
          + spark('calc(50% - 250px)', 3, 12, 0) + spark('calc(50% + 450px)', 18, 14, -2.3) + spark('max(3%, calc(50% - 560px))', 62, 14, -1.1)
          + spark('min(97%, calc(50% + 560px))', 72, 12, -0.6) + spark('calc(50% - 470px)', 86, 10, -1.8) + spark('calc(50% + 470px)', 90, 10, -2.7);
      box.prepend(zone(el('span', 'tc-hw-promo__fx', h)));
    });
  };

  // the Halloween collection's own page: the title band becomes the night (stars, bats crossing, swarms pouring in from
  // the side), and the grid gets bats hanging behind the cards plus bats and swarms crossing over them now and then
  const hauntedPage = () => {
    if (!onHaunted) return;
    const band = document.querySelector('.breadcrumb-section');
    if (band && !band.querySelector(':scope > .tc-hw-night')) {
      const night = zone(el('span', 'tc-hw-night tc-hw-night--col'));
      const sky = el('span', 'tc-hw-sky');
      sky.innerHTML = stars(phone() ? 18 : 34);
      const bats = el('span', 'tc-hw-bats');
      night.append(sky, bats);
      host(band).prepend(night); // under the mist that pages() put along its bottom
      if (!reduce) flyBats(night, bats, { band: [0.1, 0.7], edge: true });
    }
    const grid = document.querySelector('.tc-collection');
    if (grid && !grid.querySelector(':scope > .tc-hw-haunt')) {
      const ph = phone(), rows = ph ? 9 : 8;
      let h = '';
      // two bats per band of the page, one on each side, plus sparkles: spread down the whole grid
      for (let k = 0; k < rows; k++) {
        const y = ((k + 0.5) / rows) * 100;
        h += `<span class="tc-hw-promo__bat" style="--x:${R(1, ph ? 8 : 14).toFixed(1)}%;--y:${(y + R(-3, 3)).toFixed(1)}%;--s:${R(0.4, ph ? 0.6 : 0.85).toFixed(2)};--d:${(-R(0, 6)).toFixed(2)}s;--t:${R(5, 7.5).toFixed(2)}s">${batSvg()}</span>`;
        h += `<span class="tc-hw-promo__bat" style="--x:${R(ph ? 84 : 80, 95).toFixed(1)}%;--y:${(y + R(-3, 3)).toFixed(1)}%;--s:${R(0.4, ph ? 0.6 : 0.85).toFixed(2)};--d:${(-R(0, 6)).toFixed(2)}s;--t:${R(5, 7.5).toFixed(2)}s">${batSvg()}</span>`;
        h += `<i class="tc-hw-promo__spark" style="--x:${R(3, 97).toFixed(1)}%;--y:${(y + R(-4, 4)).toFixed(1)}%;--w:${R(8, 14).toFixed(0)}px;--d:${(-R(0, 3)).toFixed(2)}s"></i>`;
      }
      grid.prepend(zone(el('span', 'tc-hw-promo__fx tc-hw-haunt', h)));
      const sky = zone(el('span', 'tc-hw-haunt-sky'));
      const bats = el('span', 'tc-hw-bats');
      sky.append(bats);
      grid.append(sky);
      if (!reduce) flyBats(sky, bats, { band: [0.04, 0.92], solo: ph ? 3 : 5, edge: true });
    }
  };

  // the code chips copy their code, and say so for a moment
  const copy = () => {
    document.addEventListener('click', (e) => {
      const b = e.target.closest && e.target.closest('[data-tc-hw-copy]');
      if (!b) return;
      const code = b.dataset.tcHwCopy, say = b.querySelector('.tc-hw-code__say'), told = b.querySelector('.tc-hw-code__live');
      const done = () => {
        if (!b.dataset.was) b.dataset.was = say.textContent;
        say.textContent = b.dataset.done;
        if (told) told.textContent = b.dataset.done;
        b.classList.add('is-copied');
        clearTimeout(b.tcHwT);
        b.tcHwT = setTimeout(() => { say.textContent = b.dataset.was; b.classList.remove('is-copied'); if (told) told.textContent = ''; }, 2200);
      };
      const old = () => {
        const t = document.createElement('textarea');
        t.value = code; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;top:0;opacity:0';
        document.body.append(t); t.select();
        try { document.execCommand('copy'); } catch (x) { /* nothing more to try */ }
        t.remove(); done();
      };
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, old); else old();
    });
  };

  // ---------- music ----------
  // a Halloween track (assets/tc-hw-music.mp3: "Halloween" by Nastelbom, from Pixabay) for a haunted night, played on
  // a loop only when the visitor asks; it fades in and out (where the browser lets a page set the volume)
  const music = () => {
    if (!T.music || !T.src || document.querySelector('.tc-hw-music')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tc-hw-music';
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 18V5l11-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="17" cy="16" r="3"/></svg><span class="tc-hw-music__eq" aria-hidden="true"><i></i><i></i><i></i></span>';
    // the labels come HTML-escaped from the translations
    const dec = (v) => { const t = document.createElement('textarea'); t.innerHTML = v || ''; return t.value; };
    const label = (on) => { const t = dec(on ? T.stop : T.play); btn.setAttribute('aria-label', t); btn.title = t; btn.setAttribute('aria-pressed', String(on)); btn.classList.toggle('is-on', on); };
    label(false);
    document.body.append(btn);
    // nothing plays until the visitor presses the button; once they have, it carries on to the next page at their
    // first tap, from where it was
    const VOL = 0.7;
    let audio, fade, on = false;
    const ramp = (to, ms, then) => {
      clearInterval(fade);
      const from = audio.volume, t0 = performance.now();
      fade = setInterval(() => {
        const k = Math.min(1, (performance.now() - t0) / ms);
        audio.volume = from + (to - from) * k;
        if (k >= 1) { clearInterval(fade); if (then) then(); }
      }, 30);
    };
    const start = () => {
      if (!audio) {
        audio = new Audio(T.src);
        audio.loop = true;
        try { const at = parseFloat(sessionStorage.getItem('tcHwMusicAt')); if (at > 0) audio.currentTime = at; } catch (e) { /* private mode */ }
      }
      on = true;
      label(true);
      try { sessionStorage.setItem('tcHwMusic', '1'); } catch (e) { /* private mode */ }
      audio.volume = 0;
      const p = audio.play();
      if (p && p.catch) p.catch(() => { on = false; label(false); });
      ramp(VOL, 1400);
    };
    const stop = () => {
      on = false;
      label(false);
      try { sessionStorage.removeItem('tcHwMusic'); } catch (e) { /* private mode */ }
      if (audio) ramp(0, 500, () => { if (!on) audio.pause(); });
    };
    btn.addEventListener('click', () => (on ? stop() : start()));
    document.addEventListener('visibilitychange', () => { if (audio && on) { if (document.hidden) audio.pause(); else audio.play().catch(() => {}); } });
    window.addEventListener('pagehide', () => { if (audio && on) { try { sessionStorage.setItem('tcHwMusicAt', String(audio.currentTime)); } catch (e) { /* private mode */ } } });
    let wanted = false;
    try { wanted = sessionStorage.getItem('tcHwMusic') === '1'; } catch (e) { /* private mode */ }
    if (wanted) {
      const go = (e) => {
        if (e.target.closest && e.target.closest('.tc-hw-music')) return;
        ['pointerdown', 'keydown'].forEach((n) => window.removeEventListener(n, go, true));
        if (!on) start();
      };
      ['pointerdown', 'keydown'].forEach((n) => window.addEventListener(n, go, true));
    }
  };

  const run = () => {
    if (!document.querySelector('.tc-hw-defs')) document.body.insertAdjacentHTML('afterbegin', DEFS);
    hero(); values(); worlds(); light(); trust(); banner(); promo(); pages(); hauntedPage(); product(); popups(); footer();
  };
  const once = () => { run(); cards(); peeks(); copy(); music(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', once); else once();
  // the theme editor re-renders sections
  document.addEventListener('shopify:section:load', run);
})();
